import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { apiService, getAuthCredentials } from './services/api'
import SetupPage from './pages/SetupPage'
import LoginPage from './pages/LoginPage'
import HomePage from './pages/HomePage'
import AddReceiptPage from './pages/AddReceiptPage'
import SearchPage from './pages/SearchPage'
import ReportsPage from './pages/ReportsPage'
import AdminPage from './pages/AdminPage'
import Layout from './components/Layout'
import LoadingSpinner from './components/LoadingSpinner'
import { OverlayProvider } from './context/OverlayContext'

function App() {
  // Check setup status
  const { data: setupStatus, isLoading: setupLoading } = useQuery({
    queryKey: ['setupStatus'],
    queryFn: apiService.getSetupStatus,
    retry: 3,
    retryDelay: 1000,
  })

  // Check if user is authenticated
  const isAuthenticated = getAuthCredentials() !== null

  if (setupLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  // Show setup page if setup is not complete
  if (setupStatus && !setupStatus.is_setup_complete) {
    return <SetupPage />
  }

  // Show login page if not authenticated
  if (!isAuthenticated) {
    return <LoginPage />
  }

  // Show main app
  return (
    <OverlayProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/upload" element={<AddReceiptPage />} />
          <Route path="/manual" element={<AddReceiptPage />} />
          <Route path="/add" element={<AddReceiptPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/monthly" element={<HomePage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </Layout>
    </OverlayProvider>
  )
}

export default App